import { render, staticRenderFns } from "./PHFCli.vue?vue&type=template&id=08d67104&"
import script from "./PHFCli.vue?vue&type=script&lang=js&"
export * from "./PHFCli.vue?vue&type=script&lang=js&"
import style0 from "./PHFCli.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports